<template>
	<div class="StoreInventory">
		<el-row :gutter="10" class="mt-2">
			<el-col :xs="24" :sm="8" :md="5" :lg="5" :xl="5">
				<div class="store-inventory-card">
					<p class="inventory-card-value">INR XXXXXXXXXX</p>
					<p class="inventory-card-label">Total Inventory</p>
				</div>
			</el-col>
			<el-col :xs="24" :sm="8" :md="5" :lg="5" :xl="5">
				<div class="store-inventory-card">
					<p class="inventory-card-value">INR XXXXXXXXXX</p>
					<p class="inventory-card-label">Store</p>
				</div>
			</el-col>
			<el-col :xs="24" :sm="8" :md="5" :lg="5" :xl="5">
				<div class="store-inventory-card">
					<p class="inventory-card-value">INR XXXXXXXXXX</p>
					<p class="inventory-card-label">Warehouse</p>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
				<div class="store-inventory-card">
					<p class="inventory-card-value">INR XXXXXXXXXX</p>
					<p class="inventory-card-label">Usage</p>
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :lg="4" :xl="4" :md="4">
				<div class="store-inventory-card">
					<p class="inventory-card-value">0 Days</p>
					<p class="inventory-card-label">Coverage Days</p>
				</div>
			</el-col>
		</el-row>
		<InventoryDashboardTab></InventoryDashboardTab>
		<div>
			<BaseTable :table-data="tempTD">
				<template slot="headingOfTable">
					<div>
						Store Inventory
					</div>
				</template>
				<template slot="button" slot-scope="{ element, indexOfRow }">
					<span
						:class="[
							element.value == 'Consolidated' ? 'bold-link' : 'active-link'
						]"
						@click="rowButtonClicked(element, indexOfRow)"
					>
						{{ element.value ? element.value : "-" }}
					</span>
				</template>
			</BaseTable>
		</div>
	</div>
</template>

<script>
import BaseLocationsDropdown from "../../../baseLocationsDD/BaseLocationsDD.vue";
import BaseCategoriesDropdown from "../../../baseCategoriesDD/BaseCategoriesDD.vue";
import InventoryDashboardTab from "../inventoryDashboard/inventoryDasboardTab/InventoryDashboardTab.vue";
export default {
	name: "StoreInventory",
	components: {
		// BaseLocationsDropdown,
		// BaseCategoriesDropdown,
		InventoryDashboardTab
	},
	data() {
		return {
			quickReports: "",
			dateFrom: "",
			dateTo: "",
			tempTD: {
				data: {
					headingMain: [
						{ value: "Store ID", colspan: 1, isBorder: true },
						{ value: "Achievement", colspan: 4, isBorder: true },
						{ value: "Target", colspan: 4, isBorder: true }
					],
					headings: [
						{ value: "Store Name", colspan: 1, isBorder: true },
						{ value: "This Year", colspan: 1, isBorder: true },
						{ value: "Last Period", colspan: 1, isBorder: true },
						{ value: "Last Year", colspan: 1, isBorder: true },
						{ value: "YoY%", colspan: 1, isBorder: true },
						{ value: "Total YTD", colspan: 1, isBorder: true },
						{ value: "Forecast", colspan: 1, isBorder: true },
						{ value: "Difference", colspan: 1, isBorder: true },
						{ value: "Difference%", colspan: 1, isBorder: true }
					],
					subHeading: [],
					rows: [
						[
							{
								id: "18d78a30-9ceb-478b-b174-b7dfe6c2e616",
								value: "outlet #13",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 8849, isBorder: false, isconsolidatedRow: false },
							{ value: 8849, isBorder: false, isconsolidatedRow: false },
							{ value: 13043, isBorder: false, isconsolidatedRow: false },
							{ value: -32.16, isBorder: true, isconsolidatedRow: false },
							{ value: 1380693, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 8849, isBorder: false, isconsolidatedRow: false },
							{ value: 67.84, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "4d58ce6f-9261-43e3-8ac7-92b5cf93b3ba",
								value: "outlet #1",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 11378, isBorder: false, isconsolidatedRow: false },
							{ value: 11378, isBorder: false, isconsolidatedRow: false },
							{ value: 5837, isBorder: false, isconsolidatedRow: false },
							{ value: 94.93, isBorder: true, isconsolidatedRow: false },
							{ value: 1371982, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 11378, isBorder: false, isconsolidatedRow: false },
							{ value: 194.93, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "5533d759-220e-4831-8479-14c202963482",
								value: "outlet #10",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 12363, isBorder: false, isconsolidatedRow: false },
							{ value: 12363, isBorder: false, isconsolidatedRow: false },
							{ value: 14805, isBorder: false, isconsolidatedRow: false },
							{ value: -16.49, isBorder: true, isconsolidatedRow: false },
							{ value: 1781260, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 12363, isBorder: false, isconsolidatedRow: false },
							{ value: 83.51, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "560fe709-4c35-4870-95a1-f1841690a78e",
								value: "outlet #14",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 4575, isBorder: false, isconsolidatedRow: false },
							{ value: 4575, isBorder: false, isconsolidatedRow: false },
							{ value: 8041, isBorder: false, isconsolidatedRow: false },
							{ value: -43.1, isBorder: true, isconsolidatedRow: false },
							{ value: 1725112, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 4575, isBorder: false, isconsolidatedRow: false },
							{ value: 56.9, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "65514079-8931-4f9f-aca9-99e399331355",
								value: "outlet #15",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 16049, isBorder: false, isconsolidatedRow: false },
							{ value: 16049, isBorder: false, isconsolidatedRow: false },
							{ value: 6474, isBorder: false, isconsolidatedRow: false },
							{ value: 147.9, isBorder: true, isconsolidatedRow: false },
							{ value: 1543218, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 16049, isBorder: false, isconsolidatedRow: false },
							{ value: 247.9, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "66ac0fdb-06c3-4bc9-87f6-15e31057a7b8",
								value: "outlet #11",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 6098, isBorder: false, isconsolidatedRow: false },
							{ value: 6098, isBorder: false, isconsolidatedRow: false },
							{ value: 13221, isBorder: false, isconsolidatedRow: false },
							{ value: -53.88, isBorder: true, isconsolidatedRow: false },
							{ value: 1666187, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 6098, isBorder: false, isconsolidatedRow: false },
							{ value: 46.12, isBorder: false, isconsolidatedRow: false }
						]
					]
				}
			},
			outlet2Categories: {
				data: {
					headingMain: [
						{ value: "Store ID", colspan: 1, isBorder: true },
						{ value: "Achievement", colspan: 4, isBorder: true },
						{ value: "Target", colspan: 4, isBorder: true }
					],
					headings: [
						{ value: "Category Name", colspan: 1, isBorder: true },
						{ value: "This Year", colspan: 1, isBorder: true },
						{ value: "Last Period", colspan: 1, isBorder: true },
						{ value: "Last Year", colspan: 1, isBorder: true },
						{ value: "YoY%", colspan: 1, isBorder: true },
						{ value: "Total YTD", colspan: 1, isBorder: true },
						{ value: "Forecast", colspan: 1, isBorder: true },
						{ value: "Difference", colspan: 1, isBorder: true },
						{ value: "Difference%", colspan: 1, isBorder: true }
					],
					subHeading: [],
					rows: [
						[
							{
								id: "f6a5fb48-99d8-4e46-a0e7-6c346fc18988",
								value: "category #7",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 2376, isBorder: false, isconsolidatedRow: false },
							{ value: 2376, isBorder: false, isconsolidatedRow: false },
							{ value: 2686, isBorder: false, isconsolidatedRow: false },
							{ value: -11.54, isBorder: true, isconsolidatedRow: false },
							{ value: 200088, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 2376, isBorder: false, isconsolidatedRow: false },
							{ value: 88.46, isBorder: false, isconsolidatedRow: false }
						],
						[
							{
								id: "1ddbbd24-54bb-46b9-8588-fdfa867a7519",
								value: "category #4",
								isBorder: true,
								isClickable: true,
								isShowGraph: false,
								isClickedAlready: false
							},
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 1914, isBorder: false, isconsolidatedRow: false },
							{ value: -100, isBorder: true, isconsolidatedRow: false },
							{ value: 92642, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false },
							{ value: 0, isBorder: false, isconsolidatedRow: false }
						]
					]
				}
			}
		};
	},
	mounted() {
		this.$emit("resetPageInfoEvent", {
			pageInfo: {
				currentPage: 1,
				pageSize: 10
			}
		});
	},
	methods: {
		locationDropdownUpdate() {},
		categoryDropdownUpdate() {},
		rowButtonClicked(element, indexOfRow) {
			console.log("element in sales location", element, indexOfRow);
			if (element.isClickedAlready) {
				this.tempTD.data.rows.splice(
					indexOfRow + 1,
					this.outlet2Categories.data.rows.length
				);
				element.isClickedAlready = false;
			} else {
				this.tempTD.data.rows.splice(
					indexOfRow + 1,
					0,
					...this.outlet2Categories.data.rows
				);
				element.isClickedAlready = true;
			}
			console.log("this.tempTD.data.rows", this.tempTD.data.rows);
			// if (element.isShowGraph) {
			// 	this.showGraphForPartRow(indexOfRow);
			// }
			// EventBus.$emit("buttonClickedEvent", element);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./StoreInventory.scss";
</style>
